import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const SectionEyebrow = ({ children, dark = false }) => (
  <div className="flex items-center gap-3 mb-4">
    <span className="h-[2px] w-8 bg-oyf-yellow" />
    <span className={`text-xs font-bold tracking-[0.2em] uppercase ${dark ? "text-oyf-yellow" : "text-oyf-medgrey"}`}>
      {children}
    </span>
  </div>
);
